import { useState, useEffect } from "react";

const events = [
  { name: "Wednesday Bible Study", day: 3, hour: 19, minute: 0 },
  { name: "Leadership Training", day: 0, hour: 8, minute: 0 },
  { name: "Worship Encounter", day: 0, hour: 11, minute: 0 },
];

const CountdownTimer = () => {
  const [countdown, setCountdown] = useState({ d: 0, h: 0, m: 0, s: 0, name: "" });

  useEffect(() => {
    const update = () => {
      const now = new Date();
      let nextEvent = null;
      let minDiff = Infinity;

      events.forEach((event) => {
        const target = new Date(now);
        target.setHours(event.hour, event.minute, 0, 0);
        let dayDiff = (event.day - now.getDay() + 7) % 7;
        if (dayDiff === 0 && now > target) dayDiff = 7;
        target.setDate(now.getDate() + dayDiff);
        const diff = target - now;
        if (diff < minDiff) {
          minDiff = diff;
          nextEvent = { ...event, date: target };
        }
      });

      setCountdown({
        d: Math.floor(minDiff / (1000 * 60 * 60 * 24)),
        h: Math.floor((minDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        m: Math.floor((minDiff % (1000 * 60 * 60)) / (1000 * 60)),
        s: Math.floor((minDiff % (1000 * 60)) / 1000),
        name: nextEvent?.name || "",
      });
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="bg-black py-5 px-6" data-testid="countdown-timer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Event Name */}
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-[#FFB800] rounded-full animate-pulse" />
          <p className="font-['Satoshi'] text-xs md:text-sm font-bold tracking-[0.15em] uppercase text-zinc-400" data-testid="countdown-event-name">
            Next: {countdown.name}
          </p>
        </div>

        {/* Timer */}
        <div className="flex items-center gap-1" data-testid="countdown-display">
          {[
            { val: countdown.d, label: "Days" },
            { val: countdown.h, label: "Hrs" },
            { val: countdown.m, label: "Min" },
            { val: countdown.s, label: "Sec" },
          ].map((unit, i) => (
            <div key={unit.label} className="flex items-center">
              <div className="text-center">
                <span className="font-['Clash_Display'] font-bold text-2xl md:text-3xl text-white leading-none" data-testid={`countdown-${unit.label.toLowerCase()}`}>
                  {pad(unit.val)}
                </span>
                <p className="font-['Satoshi'] text-[10px] text-zinc-500 uppercase tracking-wider mt-1">
                  {unit.label}
                </p>
              </div>
              {i < 3 && (
                <span className="font-['Clash_Display'] text-xl text-[#FFB800] mx-2 md:mx-3 -mt-4">:</span>
              )}
            </div>
          ))}
        </div>

        {/* Watch Live Link */}
        <a
          href="https://www.youtube.com/@leonardlucas2293"
          target="_blank"
          rel="noopener noreferrer"
          className="font-['Satoshi'] text-sm font-bold text-[#FFB800] hover:text-white transition-colors uppercase tracking-wider"
          data-testid="countdown-watch-link"
        >
          Watch Live
        </a>
      </div>
    </div>
  );
};

export default CountdownTimer;
